export default __webpack_public_path__ + "static/media/delete-btn.cfb3578a.svg";